import React, { Component } from 'react';
import ReCaptchaContainer from '../recaptcha/ReCaptchaContainer';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';
import PropTypes from 'prop-types';

const propTypes = {
    reCaptchaPublicKey: PropTypes.string.isRequired,
    reCaptchaOnloadCallbackName: PropTypes.string.isRequired,
    reCaptchaDisabled: PropTypes.bool.isRequired,
    workflowNavElementId: PropTypes.string
};

const defaultProps = {
    reCaptchaDisabled: false
};

class PhoneSelectorContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reCaptchaIsValid: false
        };
        this.handleReCaptchaChange = this.handleReCaptchaChange.bind(this);
    }

    handleReCaptchaChange() {
        this.setState({ reCaptchaIsValid: true });
    }

    isNextEnabled() {
        if (this.props.reCaptchaDisabled) {
            return true;
        }
        return this.state.reCaptchaIsValid;
    }

    render() {
        var reCaptchaComponent = this.props.reCaptchaDisabled ? null : (
            <ReCaptchaContainer
                clsName="mfa-recaptcha-centered"
                reCaptchaPublicKey={this.props.reCaptchaPublicKey}
                onloadCallbackName={this.props.reCaptchaOnloadCallbackName}
                verifyCallback={this.handleReCaptchaChange}
            />
        );

        return (
            <div>
                {reCaptchaComponent}
                <WorkflowNavContainer
                    primaryButtonText="Next"
                    primaryButtonSubmitEnabled={this.isNextEnabled()}
                    elementId={this.props.workflowNavElementId}
                />
            </div>
        );
    }
}

PhoneSelectorContainer.propTypes = propTypes;
PhoneSelectorContainer.defaultProps = defaultProps;
export default PhoneSelectorContainer;
